document.addEventListener('DOMContentLoaded', (event) => {
  document.getElementById('mobile-menu-btn').addEventListener('click', toggleMobileMenu, false);
  document.getElementById('mobile-menu').style.transform =
    'translate(' + document.getElementById('mobile-menu').offsetWidth + ')';
});

function toggleMobileMenu() {
  let menu = document.getElementById('mobile-menu');
  let allcontent = document.getElementById('all-content');

  if (menu.style.display == 'block') {
    allcontent.style.overflow = "scroll";
    gsap.to(menu, {
      duration: 0.4,
      ease: 'power4.out',
      x: menu.offsetWidth,
      onComplete: () => {
        menu.style.display = 'none';
      },
    });
  } else {
    allcontent.style.overflow = "hidden";
    menu.style.display = 'block';
    gsap.fromTo(
      menu,
      {
        duration: 0,
        x: menu.offsetWidth,
      },
      {
        x: 0,
        duration: 0.4,
        ease: 'power4.out',
      }
    );
  }
}
